module.exports = __webpack_public_path__ + "static/media/ReactiveMovieDB.a7768d42.jpg";